export default __webpack_public_path__ + "static/media/preview-elite.83ef72df.gif";